<template>
  <div class="contact">
    <p>Merci de votre intérêt pour les scooters Rider. Toute l'équipe se fera un plaisir de vous répondre dans les
      meilleurs délais.</p>
    <div>
      <label for="choose">Votre question concerne :</label>
      <select id="choose" v-model.number="choice">
        <option value="0"></option>
        <option value="1">Les tarifs et/ou l'achat de scooters rider</option>
        <option value="2">Des informations complémentaires</option>
      </select>
    </div>
    <div class="contact__go2roues" v-show="choice === 1">
      <p>Pour toute commande, les modèles Rider sont disponibles à l'achat <a
        href="https://www.go2roues.com/shop/marque/rider/">sur le
        site de go2roues</a> ou par téléphone au 09 74 59 58 10.</p>
      <p><a href="https://www.go2roues.com/" class="button">COMMANDER CHEZ GO2ROUES</a></p>
    </div>
    <form v-show="choice === 2 && !sent" ref="form">
      <div>
        <label for="prenom">Prénom</label>
        <input id="prenom" type="text" v-model="first_name" required>
      </div>
      <div>
        <label for="nom">Nom</label>
        <input id="nom" type="text" v-model="last_name" required>
      </div>
      <div>
        <label for="email">Email</label>
        <input id="email" type="email" v-model="email" required>
      </div>
      <div>
        <label for="phone">Téléphone</label>
        <input id="phone" type="text" v-model="phone" minlength="10" maxlength="10" required
               pattern="^(?:0|\(?\+33\)?\s?|0033\s?)[1-79](?:[\.\-\s]?\d\d){4}$">
      </div>
      <div>
        <label for="message">Votre message</label>
        <textarea name="" id="message" cols="30" rows="10" v-model="message" maxlength="1000" required></textarea>
      </div>
      <div class="contact__button">
        <button ref="button" type="button" class="button" @click="post">ENVOYER</button>
      </div>
    </form>
    <div class="contact__sent" v-show="sent">
      <p>&#10003; Votre message a bien été envoyé.</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Contact",
    data() {
      return {
        choice: 0,
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        message: '',
        sent: false,
        sending: false,
      }
    },
    methods: {
      post() {
        if (this.$refs.form.checkValidity()) {
          if (!this.sending) {
            this.sending = true;
            this.$refs.button.innerHTML = `Envoi...`
            this.$api.post(`/contact/submit`, this.$data)
              .then(response => response.data)
              .then(data => {
                console.log(data)
                if (data.hasOwnProperty('id')) {
                  this.sent = true
                } else {
                  alert(`Un problème est survenu, nous somme désolé pour la gêne occasionnée.`)
                }
              })
              .finally(() => {
                this.sending = false
                this.$refs.button.innerHTML = `ENVOYER`
              })
          } else {
            this.$refs.form.reportValidity()
          }
        }
      },
    },
  }
</script>

<style scoped lang="stylus">
  .contact
    max-width 600px
    margin 0 auto 3rem

    textarea, select
      display block
      width 100%

    select
      margin-bottom: 1rem;

    .contact__go2roues
      p:last-child
        text-align center

    .button
      background-color #004560
      padding 1rem
      color white
      border-radius 4px
      margin 1rem auto
      cursor: pointer
      display inline-block

    .contact__button
      text-align right

    .contact__sent
      border 1px solid #00ccd1
      padding 1rem
      margin-bottom: 1rem;

      p
        margin-bottom: 0;
</style>
